<template>
  <div>
    <show-code :code="fieldInfoList"></show-code>
    <show-code :code="preResult"></show-code>
    <load-block :load="!load"></load-block>
    <the-edit-page
      :scheme="scheme"
      :isEntity="true"
      :loadData="loadData"
      v-if="load"
      :title="title"
      :pageMode="pageMode"
    >
      <the-controls-edit-page
        :scheme="scheme"
        :loadData="loadData"
        :saveData="saveData"
        :pathBack="pathBack"
        :show-history="!($route.name == routeNameCreate)"
        :open-history="openHistory"
        :configName="nameRoleEntity"
         :hasHistory="false"
        :roleName="nameRoleEntity"
        :pageMode="pageMode"
        :wait="wait"
      ></the-controls-edit-page>
    </the-edit-page>
    <!-- <history-person-contact
      v-if="!($route.name == 'CreateContact')"
      :modals="modals"
      :toggleModal="toggleModal"
      :closeHistory="closeHistory"
    ></history-person-contact> -->
  </div>
</template>
<script>
import TheEditPage from "../../TheEditPage.vue";
import { ATTR_VALUE } from "./store/type";
import { READ, UPDATE } from "../../../store/type";
import TheControlsEditPage from "../../TheControlsEditPage.vue";
import clearReactive from "../../../helpers/clearReactive";
import ShowCode from "../../shared/ShowCode.vue";
import convertFieldInfoListToScheme from "../../../helpers/converters/convetFieldInfoListToScheme";
import clearNull from "../../../../src/helpers/clearNull";
import { mapState } from "vuex";

import { TYPE_ERRORS } from "../../../constant";
import notify from "../../../helpers/notify/notify";
import LoadBlock from "../../shared/LoadBlock.vue";
import { checkValidate } from "../../../mixins/validate/checkValidate";
import HistoryPersonContact from "../history/HistoryPersonContact.vue";
import { pageMode } from "../../../mixins/editPage/pageMode";

import { api } from "../../../util/api";
import { API_METHODS } from "../../../constant";
import getSchemeComponet from "../../../helpers/generatorForm/getSchemeComponet";
import {NAME_OBJECT} from "../../../RoleConstanans"
export default {
  name: "EditPageAttrValue",
  components: {
    HistoryPersonContact,
    LoadBlock,
    ShowCode,
    TheControlsEditPage,
    TheEditPage
  },
  mixins: [checkValidate, pageMode],
  data() {
    return {
      wait: false,
      scheme: {},
      loadData: null,
      fieldInfoList: null,
      preResult: null,
      load: true,
      modals: {
        history: false
      },
      routeNameShow: null,
      routeNameCreate: null,
      templateValcodeId: null,
      templateConfig: null
    };
  },
  computed: {
    nameRoleEntity(){
        const nameRoute = this.$route.name
        let role = this.meta.configName
       
        switch (nameRoute) {
           case "agentCreatePagattrvalue":
           case "agentShowPageattrvalue":
           case "agentEditPageattrvalue": {
             role =  NAME_OBJECT.AttrAgency
             break
          }
          case "ClientCreatePagattrvalue":
          case "ClientShowPageattrvalue":
          case "ClientEditPageattrvalue": {
            role =  NAME_OBJECT.AttrClient
            break
          }
        }
        
        return role
    },
    ...mapState({
      lang: state => state.common.lang
    }),
    title() {
      return this.pageTitle(
        this.$t("Просмотр атрибута"),
        this.$t("Создание атрибута объекта"),
        this.$t("Редактирование атрибута")
      );
    },
    pathBack() {
      return `/${this.meta.pathBackStart}/${
        this.$route.params[this.meta.fieldRoute]
      }/edit`;
    },
    meta() {
      return this.$route.meta;
    }
  },
  watch: {
    lang() {
      this.initData();
    },
    loadData: {
      deep: true,
      handler(val) {
          if(this.templateValcodeId !== val.attrEntityId && val.attrEntityId !== 0 ) {
              this.getTypeValue(val.attrEntityId);
          }
          this.templateValcodeId = val.attrEntityId
      }
    }
  },
  created() {
    this.initData();
    this.routeNameShow = this.meta.routeNameShow;
    this.routeNameCreate = this.meta.routeNameCreate;
  },
  methods: {
    toggleModal(name) {
      this.modals[name] = !this.modals[name];
    },
    openHistory() {
      this.toggleModal("history");
    },
    closeHistory() {
      this.toggleModal("history");
      this.initData();
    },

    initData() {
      this.load = false;
      this.$store
        .dispatch(ATTR_VALUE + READ, {
          id: this.$route.params.AttrValueId || "0",
          self: this,
          SubjectId: this.$route.params[this.meta.fieldRoute]
        })
        .then(res => {
          this.templateValcodeId = res.object.attrEntityId
          this.loadData = res.object;
          let fieldInfoList = res.fieldInfoList;
          this.templateConfig =clearReactive(fieldInfoList[1])
          this.fieldInfoList = fieldInfoList; //del in future
          this.scheme.configForm = convertFieldInfoListToScheme({
            fieldInfoList,
            hasLang: false
          });
          this.preResult = convertFieldInfoListToScheme({
            fieldInfoList,
            hasLang: false
          }); //del in future
          this.loadData.subjectId = this.$route.params[this.meta.fieldRoute];
          this.load = true;
        });
    },
    saveData() {
      if (this.validateData() == false) {
        return;
      }
      let saveData = clearReactive(this.loadData);
      saveData = clearNull(saveData);
      this.wait = true;
      this.$store
        .dispatch(ATTR_VALUE + UPDATE, {
          id: this.$route.params.AttrValueId,
          saveData: saveData,
          self: this,
          SubjectId: this.$route.params[this.meta.fieldRoute]
        })
        .then(res => {
          this.wait = false;
          if (res.errors.length == 0) {
            notify(this, this.$t("Успешно"), TYPE_ERRORS.SUCCESS);
            this.$router.push({ path: this.pathBack });
          }
        })
        .catch(err => {
          console.error(err);
          this.wait = false;
        });
    },
    async getTypeValue(id) {
      let paramsIn = {
        self: this,
        id: id,
        SubjectId: this.$route.params[this.meta.fieldRoute]
      };
      try {
        let res = await api(
          API_METHODS.GET_TYPE_ATTR_VALUE,
          paramsIn,
          this.$store.state
        );
        let configForm = clearReactive(this.templateConfig) 
        configForm.type = res.object.attrValueType
        let fullSchema = getSchemeComponet(configForm.type, configForm);
        this.loadData.value = null
        this.$delete(this.scheme.configForm, 1);
        this.scheme.configForm.push(fullSchema);
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>
